import { ApolloClient } from "@apollo/client";
import {
  ICreateJournalEntryParams,
  ICreateJournalEntryRepository,
  ICreateJournalEntryRepositoryResponse,
} from "@/core/repositories/accounting";
import CREATE_JOURNAL_ENTRY from "@/core/graphql/accounting/createJournalEntry";

export class JournalEntryRepository implements ICreateJournalEntryRepository {
  constructor(private readonly client: ApolloClient) {}

  public async createJournalEntry(
    params: ICreateJournalEntryParams
  ): Promise<ICreateJournalEntryRepositoryResponse> {
    const { data } = await this.client.mutate({
      mutation: CREATE_JOURNAL_ENTRY,
      variables: {
        params,
      },
    });

    if (!data?.createJournalEntry) {
      throw new Error("Failed to create journal entry");
    }

    return data;
  }
}

